import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IVendorAlert } from "../../../../../../service/resources/booking/interfaces/IGetBookings";
import { IMomentDateFormat } from "../../../../../../interfaces/IMomentDateFormat";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { Yii } from "../../../../../../interfaces/Yii";

class Wording {
    public readonly host: string =  Yii.t('wui-shared-js', 'Fournisseur');
    public readonly text: string =  Yii.t('wui-shared-js', 'Texte');
    public readonly dateTime: string =  Yii.t('wui-shared-js', 'Date');
}

@Component({
  selector: 'vendor-alerts',
  template: `
      <div class="container">
          <table mat-table *ngIf="dataSource?.data?.length" [dataSource]="dataSource" multiTemplateDataRows>

              <ng-container matColumnDef="host">
                  <th mat-header-cell *matHeaderCellDef>{{columnLabels.host}}</th>
                  <td mat-cell *matCellDef="let element">
                      {{element.vendor?.name || element.host}}
                  </td>
              </ng-container>

              <ng-container matColumnDef="text">
                  <th mat-header-cell *matHeaderCellDef>{{columnLabels.text}}</th>
                  <td mat-cell *matCellDef="let element">
                      {{element.text}}
                  </td>
              </ng-container>

              <ng-container matColumnDef="dateTime">
                  <th mat-header-cell *matHeaderCellDef> {{columnLabels.dateTime}}</th>
                  <td mat-cell *matCellDef="let element">
                      {{element.whenLastUpdated | dateMoment: dateFormat.momentMedium}} - {{element.whenLastUpdated | dateMoment: dateFormat.momentTime}}
                  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let element;columns: displayedColumns; let i = dataIndex"
                  class="element-row"
                  [class.odd-row]="(i+1) % 2"
                  [class.even-row]="i % 2">
              </tr>
          </table>
      </div>
  `,
    styleUrls: ['vendor-alerts.component.scss']
})
export class VendorAlertsComponent implements OnInit, OnChanges {

    @Input()
    public vendorAlerts: IVendorAlert[];

    @Input()
    public vendorAlertsOrder: boolean = true;

    public dateFormat: IMomentDateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    public dataSource: MatTableDataSource<IVendorAlert>;


    public readonly columnLabels: Wording = new Wording();

    public displayedColumns: string[] = ['host', 'text', 'dateTime'];

    public ngOnInit(): void {
        this.vendorAlerts = (this.vendorAlerts || []).map((vendorAlert: IVendorAlert): IVendorAlert => {
            return {
                ...vendorAlert,
                whenCreated: moment(vendorAlert.whenCreated).toDate(),
                whenLastUpdated: moment(vendorAlert.whenCreated).toDate(),
            };
        });

        this.sortVendorAlerts();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if(changes.vendorAlertsOrder && !changes.vendorAlertsOrder.firstChange){
            this.sortVendorAlerts();
        }
    }

    private sortVendorAlerts(): void {
        this.vendorAlerts.sort((a: IVendorAlert, b: IVendorAlert): number => {
            if(this.vendorAlertsOrder) {
                return (b.whenLastUpdated as Date).getTime() - (a.whenLastUpdated as Date).getTime();
            }
            return (a.whenLastUpdated as Date).getTime() - (b.whenLastUpdated as Date).getTime();
        });

        this.dataSource = new MatTableDataSource<IVendorAlert>(this.vendorAlerts);
    }
}
